import { lazy } from "react";
import pathRoutes from "./pathRoutes";

// const HomePageHeader = lazy(
//   () => import("modules/Homepage/Pages/Header/HomePageHeader")
// );

const NewsHeader = lazy(() => import("modules/News/Pages/Header"));

const PersonalInformationHeader = lazy(
  () => import("modules/PersonnelInformation/Pages/Header")
);

const headerRoutes = [
  // {
  //   // trang chủ
  //   path: pathRoutes.homepage,
  //   page: <HomePageHeader />,
  // },
  {
    // trang tin tức
    path: pathRoutes.news.parameter,
    page: <NewsHeader />,
  },
  {
    // trang chi tiết tin tức
    path: pathRoutes.news.detail.parameter,
    page: <NewsHeader />,
  },
  // chỉnh sửa thông tin cá nhân
  {
    path: pathRoutes.personnelInformation,
    page: <PersonalInformationHeader />,
  },
];

export default headerRoutes;
